// Whether this workspace manages feedback for the public catalog, and what this
// user may do with it. Reads tenants.catalog_feedback_enabled through
// GET /api/catalog-review/capability, the same setting the server enforces.
//
// Presentation only. Hiding the sidebar item and the "Suspected catalog issue"
// action keeps APD-only UI away from other companies; the server still refuses
// every catalog route and catalog-issue decision for them.

import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';
import { getCatalogFeedbackCapability, type CatalogFeedbackCapability } from '@/lib/api';

export const NO_CATALOG_FEEDBACK: CatalogFeedbackCapability = { enabled: false, canView: false, canFlag: false, canReview: false };

export function useCatalogFeedback(): CatalogFeedbackCapability {
  const { getToken } = useAuth();
  const { data } = useQuery({
    queryKey: ['catalog-review', 'capability'],
    queryFn: () => getCatalogFeedbackCapability(() => getToken()),
    staleTime: 10 * 60_000,
    retry: false,
  });
  // Hidden until the answer is known, and on any error.
  return data ?? NO_CATALOG_FEEDBACK;
}
